import React, { useMemo } from "react";

import { colors, font } from "utils/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";

export default function OpenCloseBtn({ listId, isOpen, onClick }) {

	// Memoize the icon styles to prevent unnecessary re-renders
	const iconStyles = useMemo(() => ({
		color: isOpen ? colors.red : colors.darkBlue,
		transform: isOpen ? "rotate(90deg)" : "rotate(0deg)",
		cursor: "pointer",
		userSelect: "none",
		transition: "all 0.3s"
	}), [isOpen]);

	return (
		<div>
			<React.Fragment key={listId}>
				<FontAwesomeIcon
					onClick={onClick}
					className="open-close-icon"
					style={iconStyles}
					icon={faChevronRight}
				/>
			</React.Fragment>
			<style jsx="true">{`
				:global(.open-close-icon) {
					height: 15px;
				}
				
				@media (min-width: 768px) {
					:global(.open-close-icon) {
						height: 25px;
					}
				}
			`}</style>
		</div>
	);
}

// <style jsx="true">{`
// 	.openClose {
// 		/* padding-bottom: 0.2em; */
// 		color: ${isOpen ? colors.red : colors.darkBlue};
// 		transform: ${isOpen ? "rotate(45deg)" : "rotate(0deg)"};
// 		font-family: ${font.Athelas};
// 		transition: all 0.3s;
// 		display: block;
// 		transform-origin: center center;
// 	}
// `}</style>
